import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert/alert.service';
import { CargoService } from 'src/app/services/cargo.service';

@Component({
  selector: 'app-new-cargo',
  templateUrl: './new-cargo.component.html',
  styleUrls: ['./new-cargo.component.css']
})
export class NewCargoComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<NewCargoComponent>, 
    @Inject(MAT_DIALOG_DATA) public data:any, 
    private formBuilder: FormBuilder, 
    private cargoService: CargoService,
    private alert: AlertService
  ) { }

  ngOnInit(): void {
    this.cargarFormulario();
    if (this.data) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    this.form.reset({
      nombre: this.data.name,
      descripcion: this.data.description
    });
  }

  cargarFormulario() {
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  guardar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }

    const formData = new FormData();
    formData.append('name', this.form.value.nombre);
    formData.append('description', this.form.value.descripcion);

    this.cargoService.postCargo(formData)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        else {
          this.alert.showSave('ok');
          this.dialogRef.close(true);
        }
      },
      (err: any) => {
        this.alert.showSave('error');
      });
  }

  actualizar() {
    if (this.form.invalid) {
      this.alert.showInfo("invalid");
      return;
    }
    
    let datos = {
      name: this.form.value.nombre,
      description: this.form.value.descripcion
    };
    this.cargoService.putCargo(this.data.id, datos)
      .subscribe((res: any) => {
        if (res.data.status !== 200) {
          this.alert.showErrorCustom(res.data.mensaje);
          return;
        }
        this.alert.showUpdate("ok");
        this.dialogRef.close(true);
      },
      (err: any) => {
        this.alert.showUpdate("error");
      });
  }

}
